import { Provider } from 'preact-redux';
import store from './redux/store';
import ChatBubble from './components/ChatBubble';
import { Component } from 'preact';

import Setup from './lib/Setup';
import style from './style.scss'


if (module.hot) { require('preact/debug');}

export default class App extends Component {
    componentWillMount(){
        require('./postmessage/on.js');
        Setup.application();
    }
	render() {
		return (
            <div id='outer' >
                <Provider store={store}>
                    <ChatBubble/>
                </Provider>
            </div>
		);
	}
}



// WEBPACK FOOTER //
// ./index.js